import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { DownloadOutlined } from '@ant-design/icons';
import { createSearchParamsString } from '../../../../utils';
import { useInvoiceExportCSV } from '../../../../hooks/api/invoices';
import { useMessageError } from '../../../../hooks/common';
import downloadCSV from '../../../../utils/csv';
import { useAuth } from '../../../../store/auth';
import { isRoleEnough } from '../../../../enums/user';

function CsvExportButton() {
  const { user } = useAuth();
  const invoiceExportCSV = useInvoiceExportCSV();
  const [searchParams] = useSearchParams();

  const [isOpen, setIsOpen] = useState(false);
  const [csvString, setCsvString] = useState<string>('');

  const handleDownload = () => {
    setIsOpen(true);

    const statuses = searchParams.get('statuses')?.split(',') || [];

    // Build a new instance to modify safely
    const newParams = new URLSearchParams(searchParams);

    // Remove fields which we need to clear before sending
    newParams.delete('current');
    newParams.delete('pageSize');
    newParams.delete('statuses');

    // Add array-style statuses[]
    statuses.forEach((status) => {
      if (status) newParams.append('statuses[]', status);
    });

    const searchString = `?${newParams.toString()}`;

    invoiceExportCSV.fetch(undefined, searchString)
      .then((res) => {
        if (res && typeof res !== 'object') {
          setCsvString(res);
          setTimeout(() => downloadWithSearchParams(res), 200);
        }
      });
  };

  const downloadWithSearchParams = (res: string) => {
    const searchString = createSearchParamsString({
      ...Object.fromEntries(searchParams.entries()) || {}, current: undefined, pageSize: undefined,
    });

    downloadCSV(res, searchString);
  };

  const handleClose = () => {
    setIsOpen(false);
    setCsvString('');
  };

  useMessageError([invoiceExportCSV]);

  if (!isRoleEnough(user?.role, 'admin')) {
    return null;
  }

  return (
    <div>
      <Button type="primary" onClick={handleDownload} loading={invoiceExportCSV.loading}>
        Export CSV
      </Button>
      <Modal
        title={(
          <span>
            <DownloadOutlined />
            {' '}
            Download CSV
          </span>
        )}
        open={isOpen}
        onCancel={handleClose}
        width={320}
        footer={false}
        centered
        styles={{
          body: { textAlign: 'center' },
        }}
      >
        <p>Your download should begin automatically.</p>
        <p>If it doesn&apos;t, click the button below.</p>
        <Button type="primary" onClick={() => (csvString ? downloadWithSearchParams(csvString) : handleDownload())}>
          Download file
        </Button>
      </Modal>
    </div>
  );
}

export default CsvExportButton;
